import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { index: 0 },
  },
  {
    path: "/info",
    name: "info",
    component: () => import("../views/Info.vue"),
    meta: { index: 1 },
  },
  {
    path: "/stap1",
    name: "stap1",
    component: () => import("../views/Stap1.vue"),
    meta: { index: 2 },
  },
  {
    path: "/stap2",
    name: "stap2",
    component: () => import("../views/Stap2.vue"),
    meta: { index: 3 },
  },
  {
    path: "/stap3",
    name: "stap3",
    component: () => import("../views/Stap3.vue"),
    meta: { index: 4 },
  },
  {
    path: "/stap3b",
    name: "stap3b",
    component: () => import("../views/Stap3b.vue"),
    meta: { index: 5 },
  },
  {
    path: "/stap4",
    name: "stap4",
    component: () => import("../views/Stap4.vue"),
    meta: { index: 6 },
  },
  {
    path: "/stap4b",
    name: "stap4b",
    component: () => import("../views/Stap4b.vue"),
    meta: { index: 7 },
  },
  {
    path: "/berekening",
    name: "berekening",
    component: () => import("../views/Berekening.vue"),
    meta: { index: 7 },
  },
  {
    path: "/extrainfo",
    name: "extrainfo",
    component: () => import("../views/Extrainfo.vue"),
    meta: { index: 7 },
  },

  {
    path: "/stap5a",
    name: "stap5a",
    component: () => import("../views/Stap5a.vue"),
    meta: { index: 8 },
  },
  {
    path: "/stap5b",
    name: "stap5b",
    component: () => import("../views/Stap5b.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resulta",
    name: "resulta",
    component: () => import("../views/ResultA.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultb",
    name: "resultb",
    component: () => import("../views/ResultB.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultc",
    name: "resultc",
    component: () => import("../views/ResultC.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultd",
    name: "resultd",
    component: () => import("../views/ResultD.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resulte",
    name: "resulte",
    component: () => import("../views/ResultE.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultf",
    name: "resultf",
    component: () => import("../views/ResultF.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultg",
    name: "resultg",
    component: () => import("../views/ResultG.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resulth",
    name: "resulth",
    component: () => import("../views/ResultH.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resulti",
    name: "resulti",
    component: () => import("../views/ResultI.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultj",
    name: "resultj",
    component: () => import("../views/ResultJ.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultk",
    name: "resultk",
    component: () => import("../views/ResultK.vue"),
    meta: { index: 9 },
  },
  {
    path: "/resultl",
    name: "resultl",
    component: () => import("../views/ResultL.vue"),
    meta: { index: 9 },
  },
  {
    path: "/partners",
    name: "partners",
    component: () => import("../views/Partners.vue"),
    meta: { index: 9 },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
